// Selector to get all items in the cart
export const selectAllProducts = (state) => state.products.items;

// Selector to get status of fetching
export const selectProductStatus = (state) => state.products.status;

// Selector to get error message
export const selectProductError = (state) => state.products.error;

// Selector to get the current sort order
export const selectSortOrder = (state) => state.products.sortOrder;

// Selector to get the selected sort criteria
export const selectSortCriteria = (state) => state.products.sortCriteria;

// Selector to get the selected price range for filtering products
export const selectPriceRange = (state) => state.products.priceRange;

// Selector to get the selected categories for filtering products
export const selectSelectedCategories = (state) =>
  state.products.selectedCategories;

// Selector to get the selected color for filtering products
export const selectSelectedColors = (state) => state.products.selectedColors;

// Selector to determine if the 'On Sale' filter is active
export const selectOnSale = (state) => state.products.onSale;

// Selector to determine if the 'In Stock' filter is active
export const selectInStock = (state) => state.products.inStock;

// Selector to get selected product
export const selectSelectedProduct = (state) => state.products.selectedProduct;
